<template>
    <div class="col-lg-12 col-md-8 col-12 " id="business_client_step">
        <div class="card card-statistics">
            <div class="card-header mx-auto">
                <h3 class="card-title text-primary">Business Clients</h3>
            </div>
            <div class="card-body statistics-body ">
                <div class="row mx-auto" v-if="BusinessStore.business">
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 mb-2 mb-xl-0 mx-auto">
                        <div class="media">
                            <div class="avatar bg-light-info mr-2">
                                <div class="avatar-content">
                                    <i data-feather="users" class="avatar-icon"></i>
                                </div>
                            </div>
                            <div class="media-body my-auto">
                                <h2 class="text-bold-700 mb-0">
                                    {{ BusinessStore.business.count.leads }}
                                    <!-- {{ $count['leads'] }} -->
                                </h2>
                                <p class="card-text font-small-3 mb-0">Total Leads</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-12 mb-2 mb-sm-0 mx-auto">
                        <div class="media">
                            <div class="avatar bg-light-success mr-2">
                                <div class="avatar-content">
                                    <i data-feather="users" class="avatar-icon"></i>
                                </div>
                            </div>
                            <div class="media-body my-auto">
                                <h2 class="text-bold-700 mb-0">
                                    {{ BusinessStore.business.count.clients }}

                                    <!-- {{ 
                                    $count['clients'] 
                                }} -->
                                </h2>
                                <p class="card-text font-small-3 mb-0">Total Clients</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-12 mb-2 mb-sm-0 mx-auto">
                        <div class="media">
                            <div class="avatar bg-light-warning mr-2">
                                <div class="avatar-content">
                                    <i data-feather="user-check" class="avatar-icon"></i>
                                </div>
                            </div>
                            <div class="media-body my-auto">
                                <h2 class="text-bold-700 mb-0">
                                    {{ BusinessStore.business.count.close_clients }}
                                    <!-- {{ $count['close_clients'] }} -->
                                </h2>
                                <p class="card-text font-small-3 mb-0">Closed Clients</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, reactive } from 'vue'
import { useUserStore } from '../../../stores/UserStore.js'
import { useBusinessStore } from '../../../stores/BusinessStore.js'
export default{
    setup(){
        const userStore = useUserStore(),
        BusinessStore = useBusinessStore();
        return{
            userStore,BusinessStore
        }
    },
    watch: {
    },
    mounted() {
        
    },
}
</script>